import { render, staticRenderFns } from "./ContractorChip.vue?vue&type=template&id=ce8d91ee&scoped=true"
import script from "./ContractorChip.vue?vue&type=script&lang=ts"
export * from "./ContractorChip.vue?vue&type=script&lang=ts"
import style0 from "./ContractorChip.vue?vue&type=style&index=0&id=ce8d91ee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8d91ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce8d91ee')) {
      api.createRecord('ce8d91ee', component.options)
    } else {
      api.reload('ce8d91ee', component.options)
    }
    module.hot.accept("./ContractorChip.vue?vue&type=template&id=ce8d91ee&scoped=true", function () {
      api.rerender('ce8d91ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ContractorChip.vue"
export default component.exports